import React from 'react'
import HeroSection from '../../../shared/Rewrite/BrandPages/HeroSection'
import { scamData } from './consts'
import BrandSection from '../../../shared/BrandPages/BrandSection'
import Partners from './Partners'
import TrustReasons from './TrustReasons'
import Accordion from 'src/components/shared/FAQ/Accordion'
import ColumnToRowSection from '../../../shared/BrandPages/ColumnToRowSection'
import RecommendedReads from '../../../shared/BrandPages/RecommendedReads'
import BottomSection from '../../../shared/BrandPages/BottomSection'
import Section from '../../../shared/BrandPages/Section'
import Content from '../../../shared/BrandPages/Content'
import PrimaryButton from 'src/components/shared/PrimaryButton'
import PropTypes from 'prop-types'
import styles from './index.module.scss'
import WithSeoOverrides from 'src/components/shared/WithSeoOverride'
import { useTrustMarkers } from 'src/common/trust-markers'
import { numberFormat } from 'src/common/utils'
import EnhancedVideoPlayer from 'src/components/shared/EnhancedVideoPlayer'

const ScamPage = ({ showScheduleACallButton }) => {
  const {
    heroSectionData,
    brandDataPartners,
    partners,
    clientTestimonialsData,
    brandDataTrustReasons,
    trustReasons,
    brandDataTransparencyProgram,
    transparencyProgramFaq,
    brandDataFreedomPromises,
    freedomPromises,
    faqs,
    recommendedReads,
    bottomSectionData,
    seo,
  } = scamData

  const { getTrustMarkerById } = useTrustMarkers()
  const trustPilot = getTrustMarkerById('truspilot')

  return (
    <Content>
      <WithSeoOverrides {...seo} />
      <Section classNames="pt-0 pb-0 lg:pl-4 xl:pl-0">
        <HeroSection
          {...heroSectionData}
          contentClassName={styles.contentClassName}
          heroContainerClassName={styles.heroClassName}
          overlayShadowClassName={styles.overlayShadow}
          showNewTrustpilot
          trustPilotInfo={{
            rating: Number(trustPilot?.rating),
            totalReviews: numberFormat(Number(trustPilot?.totalReview)),
            link: trustPilot?.link,
            color: '#33b083',
          }}
          showScheduleACallButton={showScheduleACallButton}
        />
      </Section>
      <Section classNames={`py-14 bg-blue-base-white`}>
        <BrandSection
          {...brandDataPartners}
          childClassName="pt-8 lg:pt-14 order-2"
          wrapperClassName="mt-8 lg:mt-0"
        >
          <Partners data={partners} />
        </BrandSection>
      </Section>
      <Section>
        <BrandSection {...brandDataTrustReasons}>
          <TrustReasons data={trustReasons} />
        </BrandSection>
      </Section>
      <Section classNames="bg-blue-base-white py-8 lg:py-12">
        <div
          className="gap-x-primary padding-x-primary grid grid-cols-4 lg:grid-cols-12"
          data-testid="scam-testimonial-video-content"
        >
          <div className="col-span-full lg:col-span-8 lg:col-start-3">
            <BrandSection
              {...clientTestimonialsData}
              descriptionClassname="order-3 pb-3 lg:pb-0"
              childClassName="order-2 lg:order-last pt-4 lg:pt-8 flex items-center justify-center"
            >
              <div
                className="object-top pb-8 lg:pb-0"
                data-testid="scam-testimonial-video-player"
              >
                <EnhancedVideoPlayer
                  thumbnail="rounded-full h-12 w-12 md:h-20 md:w-20 bg-gray-230/20"
                  src="https://www.youtube.com/watch?v=f36VuLpX1K0"
                  className="h-52 w-84 md:h-72 md:w-130 lg:h-96 lg:w-200 xl:h-112"
                  light={'/next-assets/brand-pages/scam/video-image.webp'}
                />
              </div>
            </BrandSection>
          </div>
        </div>
      </Section>

      <Section classNames={'pb-6 pt-8 lg:py-12'}>
        <BrandSection
          {...brandDataTransparencyProgram}
          primaryBtnClassName="px-9 bg-red-950"
          childClassName="order-3"
        >
          <Accordion
            questionClassName="font-medium lg:pt-5.4"
            answerClassName="pl-4 pr-12 text-15 lg:pl-0"
            items={transparencyProgramFaq}
            isRichText={false}
          />
        </BrandSection>
      </Section>
      <Section classNames="bg-blue-base-white py-8 lg:py-12">
        <BrandSection {...brandDataFreedomPromises} childClassName="order-3">
          <ColumnToRowSection
            data={freedomPromises}
            isMobileSlider={true}
            sliderName="freedom-promises"
          />
        </BrandSection>
      </Section>
      <Section classNames={'py-8 lg:pt-12'}>
        <p
          className="p-4 text-center text-2.5xl font-bold leading-10 text-black-base lg:px-0 lg:py-5 lg:text-37 lg:leading-52"
          data-testid="scam-faq-title"
        >
          Freedom Debt Relief FAQs
        </p>
        <Accordion
          questionClassName="font-medium lg:pt-5.4"
          answerClassName="pl-4 pr-12 text-15 lg:pl-0"
          items={faqs}
        />
        <div
          className="order-4 flex justify-center pt-5 "
          data-testid="scam-faq-cta-wrapper"
        >
          <PrimaryButton
            title="Read more"
            href="/faq/"
            className="bg-blue-base px-8 py-2.5 text-white"
          />
        </div>
      </Section>
      <Section classNames="bg-blue-base-white py-8 lg:pb-16 lg:pt-8">
        <RecommendedReads data={recommendedReads} />
      </Section>
      <Section classNames="pt-0 pb-0">
        <BottomSection
          {...bottomSectionData}
          className="max-w-150"
          isDark={true}
        />
      </Section>
    </Content>
  )
}

export default ScamPage

ScamPage.defaultProps = {
  banner: {},
}
ScamPage.propTypes = {
  banner: PropTypes.object,
}
